<template>
  <div class="block" id="map_kv_rollback_log">
    <h2 style="font-size: 24px">
      KV数据回档
      <el-tooltip placement="right">
        <div slot="content">仅支持选择7天内的数据回档，请谨慎操作</div>
        <img class="img-help" src="@/assets/images/icon_help.png" />
      </el-tooltip>
    </h2>
    <div class="content-inner-wrap">
      <div class="data-filter">
        <div class="btnGroup">
          <span class="mgr25">数据表名</span>
          <el-input
            v-model="query.namespace"
            class="mgr25"
            style="width: 200px"
          />
          <span class="mgr25">数据KEY值</span>
          <el-input v-model="query.key" class="mgr25" style="width: 200px" />
        </div>
        <span class="mgr25">选择日期</span>
        <el-date-picker
          v-model="query.selectDate[0]"
          type="datetime"
          :pickerOptions="pickerOptions"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择日期时间"
        >
        </el-date-picker>
        <span style="margin: 0 10px">~</span>
        <el-date-picker
          v-model="query.selectDate[1]"
          type="datetime"
          disabled
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
        <el-button @click="handleSearch" class="search_btn" type="info">
          查询可回档数据
        </el-button>
        <span>
          <el-radio-group v-model="dayNum" size="medium" @change="clickDate">
            <el-radio-button label="2">近2天</el-radio-button>
            <el-radio-button label="7">近7天</el-radio-button>
          </el-radio-group>
        </span>
      </div>
      <el-link
        style="margin-top: 16px"
        type="primary"
        :underline="false"
        @click="showRollbackOptLog"
        >回档操作记录</el-link
      >
    </div>
    <el-dialog title="可回档kv日志" :visible.sync="showDialog" width="68%">
      <div class="data-table" v-loading="productDetailLoading">
        <el-table
          id="ssLuaErrLog"
          v-loading="productDetailLoading"
          class="data-box"
          border
          :data="list"
          stripe
        >
          <el-table-column
            scope="row"
            label="id"
            prop="aid"
            width="180"
            align="center"
          ></el-table-column>
          <el-table-column
            scope="row"
            label="logId"
            prop="logId"
            align="center"
          ></el-table-column>
          <el-table-column
            scope="row"
            label="数据表名"
            prop="namespace"
            align="center"
            width="180"
          ></el-table-column>
          <el-table-column
            scope="row"
            label="数据KEY值"
            prop="key"
            align="center"
          ></el-table-column>
          <el-table-column
            scope="row"
            label="日志时间"
            prop="time"
            width="180"
            align="center"
          ></el-table-column>
          <el-table-column
            scope="row"
            label="日志内容"
            prop="value"
            align="center"
            width="520"
          >
            <template slot-scope="scope">
              <vue-ellipsis
                :visible-line="3"
                :text="scope.row.value"
                reflow-on-resize
                :ellipsis="list[scope.$index].ellipsis"
                :on-ellipsis-click="
                  () => {
                    list[scope.$index].ellipsis = false;
                  }
                "
                :on-unellipsis-click="
                  () => {
                    list[scope.$index].ellipsis = true;
                  }
                "
              >
                <template slot="ellipsisNode">
                  <el-link
                    type="primary"
                    style="margin-left: 16px"
                    :underline="false"
                  >
                    展开</el-link
                  >
                </template>
                <template slot="unellipsisNode">
                  <el-link
                    type="primary"
                    style="margin-left: 16px"
                    :underline="false"
                  >
                    收起</el-link
                  >
                </template>
              </vue-ellipsis>
            </template>
          </el-table-column>
          <el-table-column scope="row" label="操作" prop="opt" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="rollback(scope.row)"
                >回档</el-button
              >
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="img-no">
              <img
                class="img-no-data"
                src="../../../assets/images/img_table_no_data.png"
              />
              <div class="noCart">暂无数据</div>
            </div>
          </template>
        </el-table>
      </div>
      <template #footer>
        <span>
          <el-button @click="showDialog = false">Cancel</el-button>
          <el-button type="primary" @click="showDialog = false">OK</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog
      title="kv回档操作记录"
      :visible.sync="showRollbackOptLogDialog"
      width="80%"
    >
      <el-table :data="rollbackLogs" border stripe>
        <el-table-column
          v-for="col in rollbackLogColumns"
          :prop="col.id"
          :key="col.id"
          :label="col.label"
          :width="col.width"
        >
        </el-table-column>
        <template slot="empty">
          <div class="img-no">
            <img
              class="img-no-data"
              src="../../../assets/images/img_table_no_data.png"
            />
            <div class="noCart">暂无数据</div>
          </div>
        </template>
      </el-table>
      <el-pagination
        :current-page="rollbackLogPage"
        :page-size="100"
        :small="true"
        layout="total, prev, pager, next"
        :total="rollbackLogTotal"
        @current-change="handleRollbackCurrentChange"
        style="margin-top: 20px"
      />
      <template #footer>
        <span>
          <el-button @click="showRollbackOptLogDialog = false"
            >Cancel</el-button
          >
          <el-button type="primary" @click="showRollbackOptLogDialog = false"
            >OK</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import {
  getMapKVCanRollbackLogs,
  mapKVCanRollback,
  getMapKVRollbackLog,
} from '@/api/charts';
import { formatDate } from '@/utils';

// const ONE_WEEK_TIME = 1000 * 60 * 60 * 24 * 7;
const ONE_DAY_TIME = 24 * 60 * 60 * 1000 - 1;
const ONE_DAY = 48 * 60 * 60 * 1000;
export default {
  data() {
    return {
      productDetailLoading: false,
      dayNum: 2,
      appId: '',
      mapId: '',
      list: [],
      productState: {
        type: '1', // 1 查询ss_lua_error
      },
      query: {
        selectDate: [],
        namespace: '',
        key: '',
      },
      pickerOptions: {
        disabledDate(time) {
          return (
            time.getTime() < Date.now() - 24 * 3600 * 1000 * 14 ||
            time.getTime() > Date.now()
          );
        },
      },
      showDialog: false,
      showRollbackOptLogDialog: false,
      rollbackLogs: [],
      rollbackLogColumns: [
        // { id: 'wid', label: '地图ID', width: '180' },
        { id: 'op_time', label: '回档操作时间', width: '180' },
        { id: 'namespace', label: '数据表名' },
        { id: 'kk', label: 'key' },
        { id: 'vv', label: '回档kv日志' },
        { id: 'log_time', label: '日志时间', width: '180' },
      ],
      rollbackLogPage: 1,
      rollbackLogTotal: 0,
    };
  },
  created() {
    const currTime = new Date(new Date(new Date()).toDateString()).getTime();
    this.query.selectDate = [
      formatDate(currTime - ONE_DAY),
      formatDate(new Date()),
    ];
    this.mapId = this.$route.query.id;
  },
  methods: {
    showRollbackOptLog() {
      this.showRollbackOptLogDialog = true;
      this.getRollbackLog();
    },
    handleRollbackCurrentChange(val) {
      this.rollbackLogPage = val;
      this.getRollbackLog();
    },
    handleSearch() {
      console.log('handleSearch');
      if (this.query.namespace.trim() == '*' && this.query.key.trim() == '*') {
        this.$message.error('不支持全量查询');
        return;
      }
      this.showDialog = true;
      this.getList();
    },
    getRollbackLog() {
      getMapKVRollbackLog({
        aid: this.appId || this.mapId,
        startTime: this.query.selectDate[0],
        endTime: this.query.selectDate[1],
        page: this.rollbackLogPage,
        size: 100,
      }).then(res => {
        console.log('getMapKVRollbackLog', res);
        if (res.code == 0) {
          this.rollbackLogs = (res.data.result || []).map(item => {
            return {
              ...item,
              op_time: formatDate(item.op_time * 1000),
              log_time: formatDate(item.log_time * 1000),
            };
          });
          this.rollbackLogTotal = res.data.total;
        }
      });
    },
    getList() {
      try {
        this.productDetailLoading = true;
        const params = {
          aid: this.appId || this.mapId,
          startTime: this.query.selectDate[0],
          endTime: this.query.selectDate[1],
          ns: this.query.namespace,
          key: this.query.key,
        };
        getMapKVCanRollbackLogs(params).then(res => {
          if (res.code === 0) {
            this.list = res.data.list.map(item => {
              return {
                ...item,
                ellipsis: true,
              };
            });
          }
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.productDetailLoading = false;
      }
    },
    clickDate() {
      const nowTime = new Date(new Date(new Date()).toDateString()).getTime();
      //判断选择时间是7天/30天/90天
      this.endTime =
        new Date(new Date(new Date()).toDateString()).getTime() - 1;
      // this.query.selectDate[1] = this.endTime - ONE_DAY_TIME;
      if (this.dayNum == 2) {
        this.startTime = nowTime - 48 * 60 * 60 * 1000;
      } else if (this.dayNum == 7) {
        this.startTime = nowTime - 7 * 24 * 60 * 60 * 1000;
      } else if (this.dayNum == 14) {
        this.startTime = nowTime - 14 * 24 * 60 * 60 * 1000;
      } else {
        this.startTime = nowTime - 24 * 60 * 60 * 1000;
      }
      this.query.selectDate[0] = formatDate(this.startTime);
      // this.query.selectDate[1] = formatDate(this.endTime);
      // this.getList();
      // this.handleSearch();
    },
    // async exportFn() {
    //   // TODO: 导出数据
    //   htmlToExcel.getExcel('#ssLuaErrLog', 'ss_lua_error日志');
    // },
    rollback(row) {
      console.log('rollback', row);
      this.$confirm(`确定要回档至${row.time} ${row.aid} 吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          await mapKVCanRollback({
            aid: row.aid,
            logTime: row.time,
            logId: row.logId,
            roomId: row.roomId,
          });
          this.$message({
            type: 'success',
            message: '回档成功!',
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.search_btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 0;
  color: #595959;
  border-right: 1px solid #d9d9d9;
  border-top: 1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;
  background-color: #f4f4f5;
  margin-right: 20px;
}
.btnGroup {
  margin-bottom: 15px;
}
.data-box {
  margin-top: 20px;
}
.download-wrap {
  // float: right;
  border-radius: 4px;
  font-size: 11px;
  // font-weight: 600;
  margin-top: 18px;
  margin-left: 20px;
  // display: flex;
  align-items: center;
  cursor: pointer;
  color: #2b6ddf;
  img {
    margin-right: 8px;
  }
}
.mgr25 {
  margin-right: 25px;
}
</style>
